import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IPurchaseOrder = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="19"
            viewBox="0 0 22 19"
            fill="none"
          >
            <path
              d="M1 1.08398L5.43231 2.51797L6.1493 12.3603H18.1426L20.4239 1.99652"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <circle
              cx="7.58311"
              cy="16.7186"
              r="1.33579"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
            />
            <circle
              cx="16.4479"
              cy="16.7186"
              r="1.33579"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
            />
            <line
              x1="0.75"
              y1="-0.75"
              x2="3.91831"
              y2="-0.75"
              transform="matrix(0.687645 0.726047 -0.687645 0.726047 9.14771 5.77734)"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <line
              x1="0.75"
              y1="-0.75"
              x2="3.91831"
              y2="-0.75"
              transform="matrix(-0.687645 0.726047 0.687645 0.726047 16.4717 5.77734)"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <line
              x1="12.6909"
              y1="7.59375"
              x2="12.6909"
              y2="0.750585"
              stroke={props.color??"#37474F"}
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IPurchaseOrder;
